import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
function LibasMenuVintage({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  console.log(expandedSubcategories, "this is exapand");

  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* vintage */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("vintagemain")}
          style={{
            borderBottom:
              expandedCategory === "vintagemain" ? "none" : "1px solid #dee2e6",
            borderBottomColor:
              expandedCategory === "vintagemain" ? "#333" : "#eee",
            borderBottomWidth:
              expandedCategory === "vintagemain" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/products?topic=Vintage"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "mens") {
                setHide(true);
                return;
              } else {
                setActiveFilter("mens");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight: expandedCategory === "vintagemain" ? "500" : "400",
                textDecoration:
                  expandedCategory === "vintagemain" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("vintage")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "vintagemain" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "vintagemain" ? menudown : menudown}
              alt="menudown"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "vintagemain" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of designers */}
                  <ul className="list-unstyled">
                    {/*    {t("Women")} with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to="/products?topic=Vintage&gender=WFA967se7qX0jYtySgTj&"
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            Women's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("shoes");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.shoes ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.shoes ? menudown : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for women */}
                      <AnimatePresence>
                        {expandedSubcategories?.shoes && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {/* bags */}
                            <Link
                              to="/products?topic=Vintage&id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Bags")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* clothes */}
                            <Link
                              to="/products?topic=Vintage&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Clothes")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* shoes */}
                            <Link
                              to="/products?topic=Vintage&id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Shoes")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* Accessories */}
                            <Link
                              to="/products?topic=Vintage&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Accessories")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* {t("Jewelry")} */}
                            <Link
                              to="/products?topic=Vintage&id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Jewelry")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* Watches */}
                            <Link
                              to="/products?topic=Vintage&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Watches")}
                                </motion.button>
                              </motion.li>
                            </Link>
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* mens-vintage with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to="/products?topic=Vintage&gender=KG3s4pPk3arcBux5ERnD&"
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            Men's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("mensbags");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.mensbags ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.mensbags
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for mens-vinatge */}
                      <AnimatePresence>
                        {expandedSubcategories?.mensbags && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            <Link
                              to="/products?topic=Vintage&id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Bags")}
                                </motion.button>
                              </motion.li>
                            </Link>

                            {/* clothes */}
                            <Link
                              to="/products?topic=Vintage&id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Clothes")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* Shoes */}
                            <Link
                              to="/products?topic=Vintage&id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Shoes")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* Accessories */}
                            <Link
                              to="/products?topic=Vintage&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Accessories")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* Jewelry */}
                            <Link
                              to="/products?topic=Vintage&id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Jewelry")}
                                </motion.button>
                              </motion.li>
                            </Link>
                            {/* watches */}
                            <Link
                              to="/products?topic=Vintage&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              <motion.li
                                className="py-1"
                                variants={nestedItemVariants}
                              >
                                <motion.button
                                  className="btn btn-link text-decoration-none p-0 text-dark small"
                                  whileHover={{ x: 3, color: "#000" }}
                                >
                                  {t("Watches")}
                                </motion.button>
                              </motion.li>
                            </Link>
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default LibasMenuVintage;
